import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./index/index.module').then((m) => m.IndexModule),
  },
  {
    path: 'titulado',
    loadChildren: () =>
      import('./tituladoform/tituladoform.module').then(
        (m) => m.TituladoModule
      ),
  },
  {
    path: 'captura',
    loadChildren: () =>
      import('./crm-formulario/crm/crm.module').then((m) => m.CRMModule),
  },
  {
    path: 'formacion_continua',
    loadChildren: () =>
      import('./formacion-continua/formacion-continua.module').then(
        (m) => m.FormacionContinuaModule
      ),
  },
  {
    path: 'ase',
    loadChildren: () =>
      import('./formulario-ase/formulario-ase.module').then(
        (m) => m.FormularioASEModule
      ),
  },
  {
    path: 'test',
    loadChildren: () =>
      import('./test-flujo/test-flujo.module').then((m) => m.TestFlujoModule),
  },
  {
    path: 'admision',
    loadChildren: () =>
      import('./admision/admision.module').then((m) => m.AdmisionModule),
  },
  {
    path: 'form',
    loadChildren: () =>
      import('./crm-formulario/crm-formulario.module').then(
        (m) => m.CrmFormularioModule
      ),
  },
  {
    path: 'cursos',
    loadChildren: () =>
      import('./compra-curso/compra-curso.module').then(
        (m) => m.CompraCursoModule
      ),
  },
 {
    path: 'ticketsala',
    loadChildren: () =>
      import('./ticketsala/ticketsala.module').then(
        (m) => m.TicketSalaModule
      ),
  },

  
  {
    path: '**',
    loadChildren: () =>
      import('./cuestionario/cuestionario.module').then(
        (m) => m.CuestionarioModule
      ),
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
